import { useContext, useEffect } from 'react';
import { QueryParams, TokenData } from 'helpers';
import { AppContext } from 'providers/AppProvider';
import { CurityTokenParams } from 'consts';
import { useAMLStatus } from 'hooks/useAMLStatus';
import { userAction } from 'store/actions';

export function Curity() {
	const ctx = useContext(AppContext);
	const { config, dispatch, navigate, state } = ctx;
	const { CURITY_CLIENT_ID, CURITY_CLIENT_SECRET, CURITY_OAUTH_TOKEN_URL } = config;
	const { user } = state;

	useEffect(() => {
		const [code] = QueryParams('code');
		if (code) {
			fetch(CURITY_OAUTH_TOKEN_URL, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams(CurityTokenParams(CURITY_CLIENT_ID, CURITY_CLIENT_SECRET, code)),
				method: 'post'
			})
				.then(res => res.json())
				.then(data => {
					const tokenData = TokenData(data.access_token);
					if (tokenData) {
						dispatch([
							userAction,
							{
								user: {
									...user,
									token: data.access_token
								}
							}
						]);
					}
				});
		} else {
			navigate(`../${user.flowType || 'mv'}/authenticate`);
		}
	}, []); // eslint-disable-line

	useAMLStatus();
	return null;
}
